var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSlider)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.block.toString())}}):_c('slider',_vm._l((_vm.block.childNodes),function(node,idx){return _c('div',{key:idx,domProps:{"innerHTML":_vm._s(node.innerHTML)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }